import App from "../../App";
import {DELETE_GRID, UPDATE_GRID} from "../Actions/grid";

const storageType = _ => {
    let save = null;

    // user data stored on localStorage
    Boolean((App.storage.get('redux', {user: {}}).user || {}).login_at) && (save = true);

    // user data stored on sessionStorage
    Boolean(App.session.get('user', {}).login_at) && (save = false);

    return save;
};

// if user ticked "save credential" at login process
// so the user info will be stored on localStorage
// otherwise user info will be stored on sessionStorage
const savedState = storageType() ? App.storage.get('redux', {grid: {}}).grid || {} : App.session.get('grid', {});

const initialState = {
    defaultSettings: {
        showParentHeader: true,
        showHeaderFilters: true,
        gridTheme: 'alpine',
        pinStatusColumn: 'left',
        pinOperationColumn: 'left'
    },
    ...savedState
};

const reducer = (state = initialState, action) => {
    let newState = {...state};
    const save = typeof action.save === "boolean" ? action.save : storageType(); // user specifies save type

    switch (action.type) {
        case UPDATE_GRID:

            newState[action.name] = action.config;
            break;

        case DELETE_GRID:
            delete newState[action.name];
            break;

        default:
            return newState;
    }

    if (save)
        App.storage.set('redux', {
            ...App.storage.get('redux', {}),
            grid: newState
        });
    else
        App.session.set('grid', newState);

    return newState;
};

export default reducer